<template>
  <div class="news-center">
    <div class="us_header">
      <div class="title_main">
       
      </div>
    </div>
    <div class="wrapper">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="currentList.title1" name="1">
          <div class="content">
            <div class="introduction-title">
              {{ currentList.title1 }}
            </div>
            <p class="introduction-para">
              {{ currentList.introduction1 }}
            </p>
            <p class="introduction-para">
              {{ currentList.introduction2 }}
            </p>
            <p class="introduction-para" style="padding-bottom: 12%">
              {{ currentList.introduction3 ? currentList.introduction3 : "" }}
            </p>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="currentList.title2" name="2"
          ><div class="content">
            <img
              :src="
                require('@/assets/image/digital/' + `${currentList.title2}.jpg`)
              "
            /></div
        ></el-tab-pane>
        <el-tab-pane :label="currentList.title3" name="3"
          ><div class="content">
            <img
              :src="
                require('@/assets/image/digital/' + `${currentList.title3}.jpg`)
              "
            /></div
        ></el-tab-pane>
      </el-tabs>
    </div>
    <left-float-btn></left-float-btn>
  </div>
</template>
<script>
import LeftFloatBtn from "../../../components/LeftFloatBtn";
export default {
  name: "newsCenter",
  components: {
    LeftFloatBtn,
  },
  data() {
    return {
      currentIndex: 0,
      title: [],
      type: "",
      imageName: "钢铁行业结构示意图.jpg",
      activeName: "1",
      time1: null,
      time2: null,
      currentList: {
        id: 1,
        name: "钢铁行业",
        title1: "钢铁行业数字化转型“一图四清单”简介",
        title2: "钢铁行业结构示意图",
        title3: "钢铁行业数字化转型场景图谱",
        introduction1:
          "钢铁行业是我国重要基础产业，粗钢产量连续多年全球第一，2025年预计达10.5亿吨，占全球总产量的50%同时，我国钢铁行业面临产能过剩与环保压力，绿色化、智能化成为钢铁行业核心发展方向，从“规模扩张”向“质量效益”转型。以“一图四清单”推进钢铁行业数字化转型，可以帮助相关企业明确转型重点、找准转型路径、降低转型投入，分步实现数字化、网络化、智能化转型。",
        introduction2:
          "钢铁行业“一图四清单”由工业和信息化部指导中国电子信息产业发展研究院，会同河北省工业和信息化厅、中国宝武钢铁集团有限公司、河钢集团有限公司、鞍钢集团有限公司、首钢京唐钢铁联合有限责任公司、上海宝信软件股份有限公司、中冶赛迪集团有限公司等各方共同研究编制，主要包括钢铁行业结构示意图、钢铁行业数字化转型场景图谱和钢铁行业数字化要素清单三部分。其中，钢铁行业结构示意图梳理了从钢铁行业上游到下游的主要环节，帮助各界直观了解行业特点及关键场景。钢铁行业数字化转型场景图谱是在行业结构示意图基础上，进一步按照行业业务逻辑，分环节剖析104个典型数字化场景。钢铁行业数字化要素清单梳理了相关场景数字化转型所需的工具软件、数据要素、知识模型和人才技能等4类数字化要素，并对数字化要素的需求和现状进行分析。",
      },
      lists: [
        {
          id: 1,
          name: "钢铁行业",
          title1: "钢铁行业数字化转型“一图四清单”简介",
          title2: "钢铁行业结构示意图",
          title3: "钢铁行业数字化转型场景图谱",
          introduction1:
            "钢铁行业是我国重要基础产业，粗钢产量连续多年全球第一，2025年预计达10.5亿吨，占全球总产量的50%同时，我国钢铁行业面临产能过剩与环保压力，绿色化、智能化成为钢铁行业核心发展方向，从“规模扩张”向“质量效益”转型。以“一图四清单”推进钢铁行业数字化转型，可以帮助相关企业明确转型重点、找准转型路径、降低转型投入，分步实现数字化、网络化、智能化转型。",
          introduction2:
            "钢铁行业“一图四清单”由工业和信息化部指导中国电子信息产业发展研究院，会同河北省工业和信息化厅、中国宝武钢铁集团有限公司、河钢集团有限公司、鞍钢集团有限公司、首钢京唐钢铁联合有限责任公司、上海宝信软件股份有限公司、中冶赛迪集团有限公司等各方共同研究编制，主要包括钢铁行业结构示意图、钢铁行业数字化转型场景图谱和钢铁行业数字化要素清单三部分。其中，钢铁行业结构示意图梳理了从钢铁行业上游到下游的主要环节，帮助各界直观了解行业特点及关键场景。钢铁行业数字化转型场景图谱是在行业结构示意图基础上，进一步按照行业业务逻辑，分环节剖析104个典型数字化场景。钢铁行业数字化要素清单梳理了相关场景数字化转型所需的工具软件、数据要素、知识模型和人才技能等4类数字化要素，并对数字化要素的需求和现状进行分析。",
        },
        {
          id: 2,
          name: "石化行业",
          title1: "石化行业数字化转型“一图四清单”简介",
          title2: "石化行业结构示意图",
          title3: "石化行业数字化转型场景图谱",
          introduction1:
            "石油化工是国民经济的重要支柱产业，具有产品种类多、工艺流程长、物料物性杂、工况苛刻等特点，是典型的流程制造行业。总体看，我国石化行业自动化、数字化基础较好，走在流程工业前列，但数字化网络化智能化水平仍难以满足行业高质量发展需要。以“一图四清单”场景化图谱化推进石化行业数字化转型，有助于相关企业加强数字化转型顶层谋划设计，明确发展目标和实施路径、打牢数字化基础，增强网络化互联，提升智能化水平。",
          introduction2:
            "石化行业“一图四清单”由工业和信息化部指导中国电子技术标准化研究院，会同浙江省经济和信息化厅、浙江省电子信息产品检验研究院、中控技术股份有限公司、石化盈科信息技术有限责任公司等各方共同研究编制，主要包括石化行业结构示意图、石化行业数字化转型场景图谱和石化行业数字化要素清单三部分。其中，石化行业结构示意图梳理了从行业上游到下游的主要环节，帮助各界直观了解行业特点及关键场景。石化行业数字化转型场景图谱是在行业结构示意图基础上，进一步按照行业业务逻辑，分环节剖析90 个典型数字化场景。石化行业数字化要素清单梳理了相关场景数字化转型所需的工具软件、知识模型、数据要素和人才技能4 类数字化要素，并对数字化要素的需求和现状进行分析。",
        },
        {
          id: 3,
          name: "船舶行业",
          title1: "船舶行业数字化转型“一图四清单”简介",
          title2: "船舶行业结构示意图",
          title3: "船舶行业数字化转型场景图谱",
          introduction1:
            "船舶行业是典型的重资产、长周期、技术密集型与全球化特征并存的传统产业具备高度依赖复杂供应链协同（涉及设计院、船厂、配套商及船东等全球分工），技术壁垒高（如船体线型优化、绿色动力系统研发），且强监管性（需符合IMO、船级社等国际标准）等特征。当前，船舶行业尚存在数字化转型支撑体系建设不完善，数字化核心技术及工具受制，“数据孤岛”现象普遍，供应链与产业链数字化水平不同步，质量追溯体系不健全等问题。以“一图四清单”推进船舶行业数字化转型，可以帮助相关企业明确转型重点、找准转型路径、降低转型投入，分步实现数字化、网络化、智能化转型。",
          introduction2:
            "船舶行业“一图四清单”由工业和信息化部指导中国电子技术标准化研究院，会同震兑工业智能科技有限公司、大连中远海运川崎船舶工程有限公司、中国船级社、中远海运重工有限公司等各方共同研究编制，主要包括船舶行业结构示意图、船舶行业数字化转型场景图谱和船舶行业数字化要素清单三部分。其中，船舶行业结构示意图梳理了从行业上游到下游的主要环节，帮助各界直观了解行业特点及关键场景。船舶行业数字化转型场景图谱是在行业结构示意图基础上，进一步按照行业业务逻辑，分环节剖析34个主场景91 个子场景。船舶行业数字化要素清单梳理了相关场景数字化转型所需的工具软件、数据要素、知识模型和人才技能等4 类数字化要素，并对数字化要素的需求和现状进行分析。",
        },
        {
          id: 4,
          name: "工程机械行业",
          title1: "工程机械行业数字化转型“一图四清单”简介",
          title2: "工程机械行业结构示意图",
          title3: "工程机械行业数字化转型场景图谱",
          introduction1:
            "工程机械行业具有多品种、小批量的特点，属于技术密集、劳动密集、资本密集型行业。我国工程机械行业经过多年的发展，已经成为产品类别齐全、竞争力强的重要制造业，为国家经济建设提供了坚实保障。但是国内工程机械低端重复生产、低水平竞争、高端工程机械产出能力不足等问题依然存在。以“一图四清单”推进工程机械行业数字化转型，可以帮助相关企业明确转型重点、找准转型路径、降低转型投入，分步实现数字化、网络化、智能化转型。",
          introduction2:
            "工程机械行业“一图四清单”由工业和信息化部指导国家工业信息安全发展研究中心，会同湖南省工业和信息化厅、中国工程机械工业协会、中联重科股份有限公司、广西柳工机械股份有限公司、徐州工程机械集团有限公司等各方共同研究编制，主要包括工程机械行业结构示意图、工程机械行业数字化转型场景图谱和工程机械行业数字化要素清单三部分。其中，工程机械行业结构示意图梳理了从行业上游到下游的主要环节，帮助各界直观了解行业特点及关键场景。工程机械行业数字化转型场景图谱是在行业结构示意图的基础上，进一步按照行业业务逻辑，分环节剖析46个典型数字化场景。工程机械行业数字化要素清单梳理了相关场景数字化转型所需的工具软件、数据要素、知识模型和人才技能等4 类数字化要素，并对数字化要素的需求和现状进行分析。",
        },
        {
          id: 5,
          name: "新能源汽车行业",
          title1: "新能源汽车行业数字化转型“一图四清单”简介",
          title2: "新能源汽车行业结构示意图",
          title3: "新能源汽车行业数字化转型场景图谱",
          introduction1:
            "随着汽车动力来源、生产运行方式、消费使用模式全面变革，新能源汽车产业生态正由零部件、整车研发生产及营销服务企业之间的“链式关系”，逐步演变成汽车、能源、交通等多领域多主体参与的“网状生态”。但是国内新能源汽车行业仍存在核心技术创新能力不强、产业生态尚不健全、市场竞争日益加剧等问题。以“一图四清单”推进新能源汽车行业数字化转型，帮助相关企业明确转型重点、找准转型路径、降低转型投入，分步实现数字化、网络化、智能化转型。",
          introduction2:
            "新能源汽车行业“一图四清单”由工业和信息化部指导国家工业信息安全发展研究中心，会同重庆市经济和信息化委员会、天津市工业和信息化局、广西壮族自治区工业和信息化厅、中汽研汽车工业工程（天津）有限公司、北京新能源汽车股份有限公司、厦门金龙联合汽车工业有限公司、重庆长安汽车股份有限公司等各方共同研究编制，主要包括新能源汽车行业结构示意图、新能源汽车行业数字化转型场景图谱和新能源汽车行业数字化要素清单三部分。其中，新能源汽车行业结构示意图梳理了从行业上游到下游的主要环节，帮助各界直观了解行业特点及关键场景。新能源汽车行业数字化转型场景图谱是在行业结构示意图的基础上，进一步按照行业业务逻辑，分环节剖析68个典型数字化场景。新能源汽车行业数字化要素清单梳理了相关场景数字化转型所需的工具软件、知识模型、数据要素和人才技能等4 类数字化要素，并对数字化要素的需求和现状进行分析。",
        },
        {
          id: 6,
          name: "机器人行业",
          title1: "机器人行业数字化转型“一图四清单”简介",
          title2: "机器人行业结构示意图",
          title3: "机器人行业数字化转型场景图谱",
          introduction1:
            "机器人行业具有多品种、小批量、定制化、高精度、质量要求严格等特点。近年来，行业核心技术、关键零部件和高端产品取得突破，成为经济发展、人民生活、社会治理的重要组成。尤其是随着2025 年“智能机器人”首次出现在政府工作报告中，机器人行业迎来新的发展阶段。但国内机器人同质化竞争、核心算法不足、制造技术滞后、产业链协同不足等问题依然存在。以“一图四清单”推进机器人行业数字化转型，可以帮助相关企业明确转型重点、找准转型路径、降低转型投入，分步实现数字化、网络化、智能化转型。",
          introduction2:
            "机器人行业“一图四清单”由工业和信息化部指导国家工业信息安全发展研究中心，会同中国机械工业联合会机器人分会、北京机械工业自动化研究所有限公司、长江智能制造研究院有限责任公司、埃夫特智能装备股份有限公司、沈阳新松机器人自动化股份有限公司、陕西秦川高精传动科技有限公司等各方共同研究编制，主要包括机器人行业结构示意图、机器人行业数字化转型场景图谱和机器人行业数字化要素清单三部分。其中，机器人行业结构示意图梳理了从行业上游到下游的主要环节，帮助各界直观了解行业特点及关键场景。机器人行业数字化转型场景图谱是在行业结构示意图基础上，进一步按照行业业务逻辑，分环节剖析76 个典型数字化场景。机器人行业数字化要素清单梳理了相关场景数字化转型所需的工具软件、数据要素、知识模型和人才技能等4 类数字化要素，并对数字化要素的需求和现状进行分析。",
        },
        {
          id: 7,
          name: "医疗装备行业",
          title1: "医疗装备行业数字化转型“一图四清单”简介",
          title2: "医疗装备行业结构示意图",
          title3: "医疗装备行业数字化转型场景图谱",
          introduction1:
            "医疗装备行业作为技术密集与资本密集的战略性新兴产业，具有多学科交叉、产业链条长、需求精准化等特点，是保障人民生命健康、支撑公共卫生体系建设的重要基础。近年来，我国医疗装备行业市场规模快速增长，产业链数字化水平持续提升，但在自主研发创新、数据资源共享、产业链供应链管理等方面仍然存在短板。以“一图四清单”推进医疗装备行业数字化转型，可以帮助企业明确转型升级的主攻方向和提升路径，为加快推进医疗装备行业整体转型提供路径方法指引。",
          introduction2:
            "医疗装备行业“一图四清单”由工业和信息化部指导国家工业信息安全发展研究中心，会同江苏省工业和信息化厅、上海联影医疗科技股份有限公司、深圳迈瑞生物医疗电子股份有限公司、北京天智航医疗科技股份有限公司、江苏鱼跃医疗设备股份有限公司、中国科学院深圳先进技术研究院等各方共同研究编制，主要包括医疗装备行业结构示意图、医疗装备行业数字化转型场景图谱和医疗装备行业数字化要素清单三部分。其中，医疗装备行业结构示意图梳理了从行业上游到下游的主要环节，帮助各界直观了解行业特点及关键场景。医疗装备行业数字化转型场景图谱是在行业结构示意图基础上，进一步按照行业业务逻辑，分环节剖析的120 个典型数字化场景。医疗装备行业数字化要素清单梳理了相关场景所需的工具软件、知识模型、数据要素和人才技能等4 类数字化要素，并对数字化要素的需求和现状进行了分析。",
        },
        {
          id: 8,
          name: "家电行业",
          title1: "家电行业数字化转型“一图四清单”简介",
          title2: "家电行业结构示意图",
          title3: "家电行业数字化转型场景图谱",
          introduction1:
            "家电行业产品种类丰富，涵盖冰箱、空调等大型家电和吹风机、洗地机等小型家电，应用场景广泛，是我国制造业的重要组成部分。在数字化浪潮推动下，家电行业积极转型，虽取得一定成果，但仍面临核心研发软件依赖国外、工业数据管理不善、生态引领不足以及新技术融合困难等诸多挑战。借助“一图四清单”推进家电行业数字化转型，有助于企业精准定位转型方向，优化转型路径，合理配置资源，逐步迈向数字化、网络化、智能化发展新阶段。",
          introduction2:
            "家电行业“一图四清单”由工业和信息化部指导中国工业互联网研究院，会同青岛市工业和信息化局、美云智数科技有限公司、广东美的制冷设备有限公司、海尔卡奥斯生态科技有限公司、海尔智家股份有限公司、海信集团有限公司、加西贝拉压缩机有限公司、中国家电行业协会等各方共同研究编制，主要包含家电行业结构示意图、家电行业数字化转型场景图谱以及家电行业数字化要素清单三部分。其中，家电行业结构示意图梳理了结构件、交互与感知、电控、核心零部件、整机五个家电行业的主要环节，清晰呈现行业架构及关键业务场景。家电行业数字化转型场景图谱在行业结构示意图基础上，依据行业业务逻辑，分环节深入剖析了67个典型数字化场景家电行业数字化要素清单系统梳理了相关场景数字化转型所需的工具软件、数据要素、知识模型和人才技能等4 类数字化要素，并对这些数字化要素的需求和现状进行了详细分析。",
        },
        {
          id: 9,
          name: "制糖行业",
          title1: "制糖行业数字化转型“一图四清单”简介",
          title2: "制糖行业结构示意图",
          title3: "制糖行业数字化转型场景图谱",
          introduction1:
            "制糖行业是我国国民经济发展的重要的战略产业，行业的上下游涉及链条众多，工业场景丰富、流程复杂且横跨一二三产业。制糖行业在数字化转型过程中仍面临产业链数字化贯通需求迫切、高附加值产品产出不足、工业知识经验难沉淀等一系列问题。制糖行业“一图四清单”可以帮助相关企业明确转型重点，通过数字技术应用，促进行业整体转型升级，加快制糖行业高质量发展。",
          introduction2:
            "制糖行业“一图四清单”由工业和信息化部指导国家工业信息安全发展研究中心，会同广西壮族自治区工业和信息化厅、中粮糖业控股股份有限公司、广西扶南东亚糖业有限公司、广西壮族自治区工业促进和中小企业服务中心、广西产研院人工智能与大数据应用研究所有限公司等各方共同研究编制，主要包括制糖行业结构示意图、制糖行业数字化转型场景图谱和制糖行业数字化要素清单三部分。其中，制糖行业结构示意图梳理了从行业上游到下游的主要环节，帮助各界直观了解行业特点及关键场景。制糖行业数字化转型场景图谱是在行业结构示意图基础上，进一步按照行业业务逻辑，分环节剖析22 个典型数字化场景。制糖行业数字化要素清单梳理了相关场景数字化转型所需的工具软件、数据要素、知识模型和人才技能等4 类数字化要素，并对数字化要素的需求和现状进行分析。",
        },
        {
          id: 10,
          name: "白酒行业",
          title1: "白酒行业数字化转型“一图四清单”简介",
          title2: "白酒行业结构示意图",
          title3: "白酒行业数字化转型场景图谱",
          introduction1:
            "围绕白酒行业生产、销售、管理等关键环节，系统梳理数字化转型需求，构建数字化转型场景图谱，明确数据要素、知识模型、工具软件、人才技能等四类数字化要素清单，为行业数字化转型提供系统性解决方案。",
          introduction2:
            "白酒行业“一图四清单”由工业和信息化部指导，四川省经信厅委托华为技术有限公司、赛迪研究院牵头，联合舍得酒业股份有限公司、四川省宜宾五粮液集团有限公司、泸州老窖股份有限公司等白酒企业，共同研究编制。在编制过程中，工作组深入调研白酒企业数字化转型现状，逐场景剖析行业数字化转型发展现状，解构分析转型相关数字化要素和痛点问题。通过构建数字化转型场景图谱，理清反映行业发展现状的场景链，对跨场景、跨业务、跨环节的协同情况进行模型化、结构化、数字化表达，为白酒行业数字化转型提供清晰路径。同时，针对行业数字化转型中存在的数据要素流通不畅、知识模型应用不足、工具软件适配性不强、人才技能缺口等问题，形成四类数字化要素清单，推动数据、模型、工具及数字化解决方案的自主化研发和模块化封装，加快要素的平台化沉淀和网络化共享。",
          introduction3:
            "该项目成果将有助于打通白酒行业数字化转型供需双方的话语体系，促进解决方案的培育和规模化复用，实现数字化要素的贯通和赋能，推动白酒行业数字化转型向纵深发展，提升行业整体竞争力和创新能力。",
        },
        {
          id: 11,
          name: "美妆日化行业",
          title1: "美妆日化行业数字化转型“一图四清单”简介",
          title2: "美妆日化行业结构示意图",
          title3: "美妆日化行业数字化转型场景图谱",
          introduction1: "美妆日化行业具有多品类、快迭代的特点，属于技术密集、劳动密集、营销密集型行业。我国美妆日化行业经过多年发展，已形成覆盖护肤、彩妆、个护、香氛等全品类矩阵，行业体系日趋完善，部分国货品牌通过差异化定位抢占市场份额，逐步实现从“中国制造”向“中国品牌”的转型。但行业仍面临自动化水平不高、产品同质化严重、生产设备管理成本高等问题。以“一图四清单”推进美妆日化行业数字化转型，可以帮助相关企业明确转型重点、找准转型路径、降低转型投入，分步实现数字化、网络化、智能化转型。",
          introduction2: "美妆日化行业“一图四清单”由工业和信息化部指导工业和信息化部电子第五研究所，会同广州市工业和信息化局、广州市黄埔区工业和信息化局、广州环亚化妆品科技股份有限公司、润本生物技术股份有限公司、广州蓝月亮实业有限公司等各方共同研究编制，主要包括美妆日化行业结构示意图、美妆日化行业数字化转型场景图谱和美妆日化行业数字化要素清单三部分。其中，美妆日化行业结构示意图梳理了行业关键环节，帮助各界直观了解行业特点及关键场景。美妆日化行业数字化转型场景图谱是在行业结构示意图基础上，进一步按照行业业务逻辑，分环节剖析32个典型数字化场景。美妆日化行业数字化要素清单梳理了相关场景数字化转型所需的工具软件、数据要素、知识模型和人才技能等4 类数字化要素，并对数字化要素的需求和现状进行分析。",
        },
        {
          id: 12,
          name: "锂电行业",
          title1: "锂电行业数字化转型“一图四清单”简介",
          title2: "锂电行业结构示意图",
          title3: "锂电行业数字化转型场景图谱",
          introduction1: "锂电制造过程既包含流程制造又包含离散制造（合浆到制片是流程，组装后是离散），生产工艺复杂（既有物理反应也有化学反应），是数字化转型流程复杂、场景丰富、带动效应强的代表性行业。但国内锂电行业生产数字化水平不高，面临管理水平落后、生产能力不均衡、动态信息不共享等问题。以“一图四清单”推进锂电行业数字化转型，可以帮助相关企业明确转型重点、找准转型路径、降低转型投入，分步实现数字化、网络化、智能化转型。",
          introduction2: "锂电行业“一图四清单”由工业和信息化部指导中国信息通信研究院，会同合肥国轩高科动力能源有限公司、安徽海行云物联科技有限公司等各方共同研究编制，主要包括锂电行业结构示意图、锂电行业数字化转型场景图谱和锂电行业数字化要素清单三部分。其中，锂电行业结构示意图梳理了从行业上游到下游的主要环节，帮助各界直观了解行业特点及关键场景。锂电行业数字化转型场景图谱是在行业结构示意图基础上，进一步按照行业业务逻辑，分环节剖析73 个典型数字化场景。锂电行业数字化要素清单梳理了相关场景数字化转型所需的工具软件、数据要素、知识模型和人才技能等4 类数字化要素，并对数字化要素的需求和现状进行分析。",
        },
        {
          id: 13,
          name: "印刷电路板(PCB)行业",
          title1: "印刷电路板(PCB)行业数字化转型“一图四清单”简介",
          title2: "印刷电路板(PCB)行业结构示意图",
          title3: "印刷电路板(PCB)行业数字化转型场景图谱",
          introduction1: "印刷电路板（PCB）行业具有多品种、大批量、精度要求极高的特点，属于技术密集、规模效应强的行业。我国印刷电路板（PCB）行业经过多年的发展，已经成为产品类别齐全、在全球占据重要地位的制造业，为国家经济建设提供了坚实保障。但是国内印刷电路板（PCB）行业工程软件功能弱、行业专用知识模型利用水平不足、数据资源标准化和交换机制缺乏、数字化符合技术人才缺口大等问题依然存在。以“一图四清单”推进印刷电路板（PCB）行业数字化转型，可以帮助相关企业明确转型目标、找准转型路径、降低转型成本，分布实现数字化、网络化、智能化转型。",
          introduction2: "印制电路板（PCB）行业“一图四清单”由工业和信息化部指导工业和信息化部电子第五研究所，会同深圳明阳电路科技股份有限公司、深圳市大族数控科技股份有限公司、广州广合科技股份有限公司等各方共同研究编制，主要包括印刷电路板（PCB）行业结构示意图、印刷电路板（PCB）行业数字化转型场景图谱和印刷电路板（PCB）行业数字化要素清单三部分。其中，印刷电路板（PCB）行业结构示意图梳理了从行业上游到下游的主要环节，帮助各界直观了解行业特点及关键场景。印刷电路板（PCB）行业数字化转型场景图谱是在行业结构示意图基础上，进一步按照行业业务逻辑，分环节剖析38 个典型数字化场景。印刷电路板（PCB）行业数字化要素清单梳理了相关场景数字化转型所需的工具软件、数据要素、知识模型和人才技能等4 类数字化要素，并对数字化要素的需求和现状进行分析。",
        },
        {
          id: 14,
          name: "智能移动终端",
          title1: "智能移动终端数字化转型“一图四清单”简介",
          title2: "智能移动终端结构示意图",
          title3: "智能移动终端数字化转型场景图谱",
          introduction1: "智能移动终端行业作为典型的技术密集型行业，具有生产工序复杂、产品种类繁多、产品质量要求较高等特点。我国作为全球重要的智能移动终端生产基地，产业规模优势显著、行业龙头企业众多。但整体来看，我国智能移动终端行业仍面临低端产品同质化竞争严重、柔性化生产能力不足、产品质量管控不足等行业痛点。以“一图四清单”推进智能移动终端行业数字化转型，可以帮助相关企业明确转型重点、找准转型路径、降低转型投入，分步实现数字化、网络化、智能化转型。",
          introduction2: "智能移动终端行业“一图四清单”由工业和信息化部指导工业和信息化部电子第五研究所，会同东莞市工业和信息化局、东莞华贝电子科技有限公司、广东小天才科技有限公司、OPPO广东移动通信有限公司、深圳天珑移动技术股份有限公司等各方共同研究编制，主要包括智能移动终端行业结构示意图、智能移动终端行业数字化转型场景图谱和智能移动终端行业数字化要素清单三部分。其中，智能移动终端行业结构示意图梳理了从行业上游到下游的主要环节，帮助各界直观了解行业特点及关键场景。智能移动终端行业数字化转型场景图谱是在行业结构示意图基础上，进一步按照行业业务逻辑，分环节剖析62个典型数字化场景。智能移动终端行业数字化要素清单梳理了相关场景数字化转型所需的工具软件、数据要素、知识模型和人才技能等4 类数字化要素，并对数字化要素的需求和现状进行分析。",
        },
        {
          id: 15,
          name: "民爆行业",
          title1: "民爆行业数字化转型“一图四清单”简介",
          title2: "民爆行业结构示意图",
          title3: "民爆行业数字化转型场景图谱",
          introduction1: "民用爆炸物品行业（简称“民爆行业”）是国民经济和社会发展必不可少的重要基础性行业。目前，民爆行业的数字化转型处于起步阶段，数字技术在安全生产、企业管理、质量控制、设备监测等典型场景取得初步应用，但还存在数字化转型基础薄弱、解决方案供给不够、关键技术亟待突破等问题。以“一图四清单”推进民爆行业数字化转型，可以帮助相关企业明确转型重点、找准转型路径、降低转型投入，推动民爆行业向高端化、智能化、绿色化、融合化方向转型。",
          introduction2: "民爆行业数字化转型“一图四清单”由工业和信息化部指导中国电子信息产业发展研究院，会同中国爆破器材行业协会、深圳市金奥博科技股份有限公司、江西国泰集团股份有限公司、航天云网科技发展有限责任公司、北方特种能源集团有限公司、宏大民爆集团有限公司、湖南金聚能科技有限公司、深圳市创者自动化科技有限公司、深圳市锐巽自动化设备有限公司等各方共同研究编制，主要包括民爆行业结构示意图、民爆行业数字化转型场景图谱和民爆行业数字化要素清单三部分。其中，民爆行业结构示意图梳理了乳化炸药和电子雷管两类民爆物品从行业上游到下游的主要环节，帮助各界直观了解行业特点及关键场景。民爆行业数字化转型场景图谱是在行业结构示意图基础上，进一步按照行业业务逻辑，分环节剖析38个典型数字化场景。民爆行业数字化要素清单梳理了相关场景数字化转型所需的工具软件、数据要素、知识模型和人才技能等4类数字化要素，并对数字化要素的需求和现状进行分析。",
        },
        {
          id: 16,
          name: "建材行业",
          title1: "建材行业数字化转型“一图四清单”简介",
          title2: "建材行业结构示意图",
          title3: "建材行业数字化转型场景图谱",
          introduction1: "建材行业作为资源能源密集型和流程制造型的基础性产业，具有工艺流程复杂、能耗排放高、安全生产要求严、区域布局分散等特点，是支撑国家基础设施建设和实现“双碳”目标的关键领域。近年来，我国水泥建材行业持续推进智能化改造与绿色化转型，数字化基础设施不断夯实，但在数据贯通、智能决策、能效优化和产业链协同等方面仍面临挑战。以“一图四清单”推进水泥建材行业数字化转型，有助于企业系统梳理转型路径，精准识别关键环节，明确能力提升方向，为行业高质量发展提供方法论支撑。",
          introduction2: "建材行业“一图四清单”在河南工业和信息化厅信统筹指导下，天瑞信科公司牵头研究编制，主要包括水泥建材行业结构示意图、水泥建材行业数字化转型场景图谱和水泥建材行业数字化要素清单三部分。其中，行业结构示意图系统梳理了从原材料、熟料煅烧、水泥粉磨到物流销售及碳排放管理的全链条环节；数字化转型场景图谱在此基础上，围绕生产控制、设备运维、能源管理、安全环保、供应链协同等维度，提炼出约100个典型数字化应用场景；数字化要素清单则聚焦工具软件、知识模型、数据要素和人才技能四类核心资源，分析各场景所需能力与当前供给短板，为精准投入和生态协同提供依据。",
        },
      ],
    };
  },

  mounted() {
    if (this.$route.query.id) {
      const id = this.$route.query.id;
      this.currentList = this.lists.find((ele) => ele.id == id);
      console.log(
        this.currentList,
        "this.currentListthis.currentListthis.currentList"
      );
    }
  },
  methods: {
    itemClick(item) {
      // this.$router.push({
      //   path: "/newsCenter",
      //   query: { type: item.id },
      // });
      this.type = item.id;
      this.currentIndex = item.id;
      this.time1 = setTimeout(() => {
        this.$refs.newsList.getdetail().then(() => (this.time1 = null));
      }, 0);
    },
    async getColumn() {
      const res = await this.API.operateManage.getPortalNewsChannelsFn();
      if (res.code == 200) {
        this.title = res.data;
        if (!this.$route.query.type) {
          this.currentIndex = this.title[0].id;
          this.type = this.title[0].id;
          this.time2 = setTimeout(() => {
            this.$refs.newsList.getdetail().then(() => (this.time2 = null));
          }, 0);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.news-center {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .new-detail {
    width: 900px;
    border-radius: 6px;
    margin-left: 16px;
  }
}
.us_header {
  background: url("../../../assets/image/bg.jpg") no-repeat;
  background-size: cover;
  width: 100%;
  height: 520px;
  position: relative;

  .title_main {
    position: absolute;
    left: 18.7%;
    top: 252px;

    .title_line {
      width: 68px;
      height: 8px;
      background: #ffffff;
      opacity: 1;
    }

    .zh_title {
      font-family: "Microsoft YaHei Bold";
      font-weight: 700;
      font-size: 38px;
      text-align: left;
      color: #16181a;

      margin-top: 25px;
      margin-bottom: 18px;
    }

    .eg_title {
      font-family: "Microsoft YaHei";
      font-weight: 400;
      font-size: 18px;
      color: #000;
      margin-top: 42px;
    }
  }
}
.wrapper {
  width: 80%;
  background: #fff;
  margin: auto;
  padding: 1% 2% 2% 2%;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-top: 22px;

  .title {
  }
  .content {
    margin-top: 12px;
  }
  .introduction-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #333333;
    text-align: center;
    margin-bottom: 0.8rem;
    padding-top: 0.5rem;
  }
  .introduction-para {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 36px;
    text-align: left;
    margin: 0;
    padding: 0;
    text-indent: 2em;
  }
  img {
    width: 100%;
  }
}
</style>
